/**
 * Async thunks rejected via `unwrap()` throw either the original `Error` (for
 * thunks that just re-throw) or RTK's serialized `{ name, message, ... }`
 * shape (for thunks left to reject implicitly) — neither is guaranteed to be
 * an `Error` instance, so pages use this helper instead of `err instanceof Error`.
 */
export function getErrorMessage(err: unknown, fallback = "Something went wrong"): string {
  if (err && typeof err === "object" && "message" in err) {
    const { message } = err as { message?: unknown };
    if (typeof message === "string" && message.length > 0) return message;
  }
  return fallback;
}
